import { render, staticRenderFns } from "./RiskPolicy.vue?vue&type=template&id=11de3de1"
import script from "./RiskPolicy.vue?vue&type=script&lang=js"
export * from "./RiskPolicy.vue?vue&type=script&lang=js"
import style0 from "./RiskPolicy.vue?vue&type=style&index=0&id=11de3de1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports